// extracted by mini-css-extract-plugin
export default {"personList":"index_personList_3pI3Z","item":"index_item_VozI4","name":"index_name_ie1Oi","title":"index_title_otmCK"};